import { isNullOrUndefined } from '@weft/utils';
import React from 'react';
import EmptyData from '../../assets/images/empty-data-image.svg';

export const EmptyTableOverlay: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-y-4">
      <img
        src={EmptyData}
        alt="Empty Data"
        width={200}
        height={200}
      />
      <p>
        {isNullOrUndefined(children) ? 'Nothing to show yet' : children}
      </p>
    </div>
  );
};